import React from 'react';
import { Navigate, createBrowserRouter } from 'react-router';

// Same signature as React.lazy, but reloads once when a hashed chunk from a
// previous build has gone missing (see src/utils/lazyWithReload.js). Every
// lazy() call below therefore needs no change.
import lazy from '../utils/lazyWithReload';
import RouteErrorFallback from '../components/shared/RouteErrorFallback';

import Loadable from '../layouts/full/shared/loadable/Loadable';
import ProtectedRoute from "../components/auth/ProtectedRoute"; // 🔥 Tambahkan ProtectedRoute
import PublicRoute from "../components/auth/PublicRoute";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const FullBlankLayout = Loadable(lazy(() => import('../layouts/full/BlankLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Pages***** */
const ModernDash = Loadable(lazy(() => import('../views/dashboard/Modern')));
const ModernDetail = Loadable(lazy(() => import('../views/dashboard/ModernDetail')));
const EcommerceDash = Loadable(lazy(() => import('../views/dashboard/Ecommerce')));

const Dashboard = Loadable(lazy(() => import('../views/management/dashboards/Dashboard')));
const BnfMonitoring = Loadable(lazy(() => import('../views/dashboard/BnfMonitoring')));
const Monitoring = Loadable(lazy(() => import('../views/management/monitorings/Monitoring')));
const UpdateStock = Loadable(lazy(() => import('../views/management/update-stock/UpdateStock')));
const UpdateStockHistory = Loadable(lazy(() => import('../views/management/update-stock/UpdateStockHistoryView')));

/* ****Management***** */
const Users = Loadable(lazy(() => import('../views/management/users/User')));
const AddUsers = Loadable(lazy(() => import('../views/management/users/AddUser')));
const DetailUser = Loadable(lazy(() => import('../views/management/users/DetailUser')));

const Roles = Loadable(lazy(() => import('../views/management/roles/Role')));
const AddRoles = Loadable(lazy(() => import('../views/management/roles/AddRole')));
const DetailRole = Loadable(lazy(() => import('../views/management/roles/DetailRole')));

const ShiftTimes = Loadable(lazy(() => import('../views/management/shift-times/ShiftTimes')));
const AddShiftTime = Loadable(lazy(() => import('../views/management/shift-times/AddShiftTime')));

const EmailTemplates = Loadable(lazy(() => import('../views/management/email-templates/EmailTemplate')));
import AddEmailTemplates from '../views/management/email-templates/AddEmailTemplate';
const EditEmailTemplates = Loadable(lazy(() => import('../views/management/email-templates/EditEmailTemplate')));
const DetailEmailTemplates = Loadable(lazy(() => import('../views/management/email-templates/DetailEmailTemplate')));

const EmailSchedules = Loadable(lazy(() => import('../views/management/email-schedules/EmailSchedule')));
import AddEmailSchedules from '../views/management/email-schedules/AddEmailSchedule';
const EditEmailSchedules = Loadable(lazy(() => import('../views/management/email-schedules/EditEmailSchedule')));
const DetailEmailSchedules = Loadable(lazy(() => import('../views/management/email-schedules/DetailEmailSchedule')));

const EmailRecipients = Loadable(lazy(() => import('../views/management/email-recipients/EmailRecipients')));
import AddEmailRecipients from '../views/management/email-recipients/AddEmailRecipient';
const EditEmailRecipients = Loadable(lazy(() => import('../views/management/email-recipients/EditEmailRecipient')));
const DetailEmailRecipients = Loadable(lazy(() => import('../views/management/email-recipients/DetailEmailRecipient'))); 

const Vendors = Loadable(lazy(() => import('../views/management/vendors/Vendor')));
const AddVendors = Loadable(lazy(() => import('../views/management/vendors/AddVendor')));
const DetailVendors = Loadable(lazy(() => import('../views/management/vendors/DetailVendor')));



const EwsReport = Loadable(lazy(() => import('../views/management/ewsreports/Ewsreport')));
const StockReport = Loadable(lazy(() => import('../views/management/stockreports/Stockreport')));
const FourmReport = Loadable(lazy(() => import('../views/management//fourmreports/Fourmreport')));


const Inventorys = Loadable(lazy(() => import('../views/management/inventorys/Inventory')));


const Materials = Loadable(lazy(() => import('../views/management/materials/Material')));
const AddMaterials = Loadable(lazy(() => import('../views/management/materials/AddMaterial')));
const DetailMaterials = Loadable(lazy(() => import('../views/management/materials/DetailMaterial'))); 

const System = Loadable(lazy(() => import('../views/management/systems/System')));
const AddSystem = Loadable(lazy(() => import('../views/management/systems/AddSystem')));
const DetailSystem = Loadable(lazy(() => import('../views/management/systems/DetailSystem')));

const LoginActivity = Loadable(lazy(() => import('../views/management/login-activity/LoginActivity')));
const EmailLog = Loadable(lazy(() => import('../views/management/email-log/EmailLog')));

const MenuMaster = Loadable(lazy(() => import('../views/management/menu-master/MenuMaster')));
const AddMenuMaster = Loadable(lazy(() => import('../views/management/menu-master/AddMenuMaster')));
const DetailMenuMaster = Loadable(lazy(() => import('../views/management/menu-master/DetailMenuMaster'))); 


const Forecast = Loadable(lazy(() => import('../views/management/forecasts/Forecast')));
const AddForecast = Loadable(lazy(() => import('../views/management/forecasts/AddForecast')));
const DetailForecast = Loadable(lazy(() => import('../views/management/forecasts/DetailForecast'))); 

const Forecastsupplier = Loadable(lazy(() => import('../views/management/forecastsuppliers/Forecastsupplier')));
const AddForecastsupplier = Loadable(lazy(() => import('../views/management/forecastsuppliers/AddForecastsupplier')));
const DetailForecastsupplier = Loadable(lazy(() => import('../views/management/forecastsuppliers/DetailForecastsupplier'))); 

const Business = Loadable(lazy(() => import('../views/management/business/Business')));
const AddBusiness = Loadable(lazy(() => import('../views/management/business/AddBusiness')));
const DetailBusiness = Loadable(lazy(() => import('../views/management/business/DetailBusiness'))); 



const MenusGrouping = Loadable(lazy(() => import('../views/setting/mastergroupings/Mastergrouping')));
const AddMenusGrouping = Loadable(lazy(() => import('../views/setting/mastergroupings/AddMastergrouping')));
const DetailMenusGrouping = Loadable(lazy(() => import('../views/setting/mastergroupings/DetailMastergrouping'))); 




const RolesPermission = Loadable(lazy(() => import('../views/setting/rolepermissions/Rolepermission')));
const AddRolesPermission = Loadable(lazy(() => import('../views/setting/rolepermissions/AddRolepermission')));
const DetailRolesPermission = Loadable(lazy(() => import('../views/setting/rolepermissions/DetailRolepermission'))); 


/* ****Apps***** */
const Chats = Loadable(lazy(() => import('../views/apps/chat/Chat')));
const Notes = Loadable(lazy(() => import('../views/apps/notes/Notes')));
const Calendar = Loadable(lazy(() => import('../views/apps/calendar/BigCalendar')));
const Email = Loadable(lazy(() => import('../views/apps/email/Email')));
// const Blog = Loadable(lazy(() => import('../views/apps/blog/Blog')));
// const BlogDetail = Loadable(lazy(() => import('../views/apps/blog/BlogPost')));
const Tickets = Loadable(lazy(() => import('../views/apps/tickets/Tickets')));
const Contacts = Loadable(lazy(() => import('../views/apps/contacts/Contacts')));
const Ecommerce = Loadable(lazy(() => import('../views/apps/eCommerce/Ecommerce')));
const EcommerceDetail = Loadable(lazy(() => import('../views/apps/eCommerce/EcommerceDetail')));
const EcommerceAddProduct = Loadable(lazy(() => import('../views/apps/eCommerce/EcommerceAddProduct')));
const EcommerceEditProduct = Loadable(lazy(() => import('../views/apps/eCommerce/EcommerceEditProduct')));
const EcomProductList = Loadable(lazy(() => import('../views/apps/eCommerce/EcomProductList')));
const EcomProductCheckout = Loadable(
  lazy(() => import('../views/apps/eCommerce/EcommerceCheckout')),
);
const UserProfile = Loadable(lazy(() => import('../views/apps/user-profile/UserProfile')));
const Followers = Loadable(lazy(() => import('../views/apps/user-profile/Followers')));
const Friends = Loadable(lazy(() => import('../views/apps/user-profile/Friends')));
const Gallery = Loadable(lazy(() => import('../views/apps/user-profile/Gallery')));
const InvoiceList = Loadable(lazy(() => import('../views/apps/invoice/List')));
const InvoiceCreate = Loadable(lazy(() => import('../views/apps/invoice/Create')));
const InvoiceDetail = Loadable(lazy(() => import('../views/apps/invoice/Detail')));
const InvoiceEdit = Loadable(lazy(() => import('../views/apps/invoice/Edit')));
const Kanban = Loadable(lazy(() => import('../views/apps/kanban/Kanban')));

// Pages
const RollbaseCASL = Loadable(lazy(() => import('../views/pages/rollbaseCASL/RollbaseCASL')));

const Pricing = Loadable(lazy(() => import('../views/pages/pricing/Pricing')));
const AccountSetting = Loadable(
  lazy(() => import('../views/pages/account-setting/AccountSetting')),
);
const Faq = Loadable(lazy(() => import('../views/pages/faq/Faq')));

// widget
const WidgetCards = Loadable(lazy(() => import('../views/widgets/cards/WidgetCards')));
const WidgetBanners = Loadable(lazy(() => import('../views/widgets/banners/WidgetBanners')));
const WidgetCharts = Loadable(lazy(() => import('../views/widgets/charts/WidgetCharts')));

// form elements
const MuiAutoComplete = Loadable(
  lazy(() => import('../views/forms/form-elements/MuiAutoComplete')),
);
const MuiButton = Loadable(lazy(() => import('../views/forms/form-elements/MuiButton')));
const MuiCheckbox = Loadable(lazy(() => import('../views/forms/form-elements/MuiCheckbox')));
const MuiRadio = Loadable(lazy(() => import('../views/forms/form-elements/MuiRadio')));
const MuiSlider = Loadable(lazy(() => import('../views/forms/form-elements/MuiSlider')));
const MuiDateTime = Loadable(lazy(() => import('../views/forms/form-elements/MuiDateTime')));
const MuiSwitch = Loadable(lazy(() => import('../views/forms/form-elements/MuiSwitch')));

// form layout
const FormLayouts = Loadable(lazy(() => import('../views/forms/FormLayouts')));
const FormCustom = Loadable(lazy(() => import('../views/forms/FormCustom')));
const FormWizard = Loadable(lazy(() => import('../views/forms/FormWizard')));
const FormValidation = Loadable(lazy(() => import('../views/forms/FormValidation')));
const TiptapEditor = Loadable(lazy(() => import('../views/forms/from-tiptap/TiptapEditor')));
const FormHorizontal = Loadable(lazy(() => import('../views/forms/FormHorizontal')));
const FormVertical = Loadable(lazy(() => import('../views/forms/FormVertical')));

// tables
const BasicTable = Loadable(lazy(() => import('../views/tables/BasicTable')));
const CollapsibleTable = Loadable(lazy(() => import('../views/tables/CollapsibleTable')));
const EnhancedTable = Loadable(lazy(() => import('../views/tables/EnhancedTable')));
const FixedHeaderTable = Loadable(lazy(() => import('../views/tables/FixedHeaderTable')));
const PaginationTable = Loadable(lazy(() => import('../views/tables/PaginationTable')));
const SearchTable = Loadable(lazy(() => import('../views/tables/SearchTable')));

//react tables
const ReactBasicTable = Loadable(lazy(() => import('../views/react-tables/basic/page')));
const ReactColumnVisibilityTable = Loadable(
  lazy(() => import('../views/react-tables/columnvisibility/page')),
);
const ReactDenseTable = Loadable(lazy(() => import('../views/react-tables/dense/page')));
const ReactDragDropTable = Loadable(lazy(() => import('../views/react-tables/drag-drop/page')));
const ReactEditableTable = Loadable(lazy(() => import('../views/react-tables/editable/page')));
const ReactEmptyTable = Loadable(lazy(() => import('../views/react-tables/empty/page')));
const ReactExpandingTable = Loadable(lazy(() => import('../views/react-tables/expanding/page')));
const ReactFilterTable = Loadable(lazy(() => import('../views/react-tables/filtering/page')));
const ReactPaginationTable = Loadable(lazy(() => import('../views/react-tables/pagination/page')));
const ReactRowSelectionTable = Loadable(
  lazy(() => import('../views/react-tables/row-selection/page')),
);
const ReactSortingTable = Loadable(lazy(() => import('../views/react-tables/sorting/page')));
const ReactStickyTable = Loadable(lazy(() => import('../views/react-tables/sticky/page')));

// chart
const LineChart = Loadable(lazy(() => import('../views/charts/LineChart')));
const GredientChart = Loadable(lazy(() => import('../views/charts/GredientChart')));
const DoughnutChart = Loadable(lazy(() => import('../views/charts/DoughnutChart')));
const AreaChart = Loadable(lazy(() => import('../views/charts/AreaChart')));
const ColumnChart = Loadable(lazy(() => import('../views/charts/ColumnChart')));
const CandlestickChart = Loadable(lazy(() => import('../views/charts/CandlestickChart')));
const RadialbarChart = Loadable(lazy(() => import('../views/charts/RadialbarChart')));

// ui
const MuiAlert = Loadable(lazy(() => import('../views/ui-components/MuiAlert')));
const MuiAccordion = Loadable(lazy(() => import('../views/ui-components/MuiAccordion')));
const MuiAvatar = Loadable(lazy(() => import('../views/ui-components/MuiAvatar')));
const MuiChip = Loadable(lazy(() => import('../views/ui-components/MuiChip')));
const MuiDialog = Loadable(lazy(() => import('../views/ui-components/MuiDialog')));
const MuiList = Loadable(lazy(() => import('../views/ui-components/MuiList')));
const MuiPopover = Loadable(lazy(() => import('../views/ui-components/MuiPopover')));
const MuiRating = Loadable(lazy(() => import('../views/ui-components/MuiRating')));
const MuiTabs = Loadable(lazy(() => import('../views/ui-components/MuiTabs')));
const MuiTooltip = Loadable(lazy(() => import('../views/ui-components/MuiTooltip')));
const MuiTransferList = Loadable(lazy(() => import('../views/ui-components/MuiTransferList')));
const MuiTypography = Loadable(lazy(() => import('../views/ui-components/MuiTypography')));

// authentication
const Login = Loadable(lazy(() => import('../views/authentication/auth1/Login')));
const ResetCredentials = Loadable(lazy(() => import('../views/authentication/auth1/ResetCredentials')));
const Login2 = Loadable(lazy(() => import('../views/authentication/auth2/Login2')));
const Register = Loadable(lazy(() => import('../views/authentication/auth1/Register')));
const Register2 = Loadable(lazy(() => import('../views/authentication/auth2/Register2')));
const ForgotPassword = Loadable(lazy(() => import('../views/authentication/auth1/ForgotPassword')));
const ForgotPassword2 = Loadable(
  lazy(() => import('../views/authentication/auth2/ForgotPassword2')),
);
const TwoSteps = Loadable(lazy(() => import('../views/authentication/auth1/TwoSteps')));
const TwoSteps2 = Loadable(lazy(() => import('../views/authentication/auth2/TwoSteps2')));
const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Maintenance = Loadable(lazy(() => import('../views/authentication/Maintenance')));

// landingpage
const Landingpage = Loadable(lazy(() => import('../views/pages/landingpage/Landingpage')));

// front end pages
const Homepage = Loadable(lazy(() => import('../views/pages/frontend-pages/Homepage')));
const About = Loadable(lazy(() => import('../views/pages/frontend-pages/About')));
const Contact = Loadable(lazy(() => import('../views/pages/frontend-pages/Contact')));
const Portfolio = Loadable(lazy(() => import('../views/pages/frontend-pages/Portfolio')));
const PagePricing = Loadable(lazy(() => import('../views/pages/frontend-pages/Pricing')));
const BlogPage = Loadable(lazy(() => import('../views/pages/frontend-pages/Blog')));
const BlogPost = Loadable(lazy(() => import('../views/pages/frontend-pages/BlogPost')));


//mui charts
const BarCharts = Loadable(lazy(() => import('../views/muicharts/barcharts/page')));
const GaugeCharts = Loadable(lazy(() => import('../views/muicharts/gaugecharts/page')));
const AreaCharts = Loadable(lazy(() => import('../views/muicharts/linecharts/area/page')));
const LineCharts = Loadable(lazy(() => import('../views/muicharts/linecharts/line/page')));
const PieCharts = Loadable(lazy(() => import('../views/muicharts/piecharts/page')));
const ScatterCharts = Loadable(lazy(() => import('../views/muicharts/scattercharts/page')));
const SparklineCharts = Loadable(lazy(() => import('../views/muicharts/sparklinecharts/page')));

//mui tree
const SimpletreeCustomization = Loadable(lazy(() => import('../views/mui-trees/simpletree/simpletree-customization/page')));
const SimpletreeExpansion = Loadable(lazy(() => import('../views/mui-trees/simpletree/simpletree-expansion/page')));
const SimpletreeFocus = Loadable(lazy(() => import('../views/mui-trees/simpletree/simpletree-focus/page')));
const SimpletreeItems = Loadable(lazy(() => import('../views/mui-trees/simpletree/simpletree-items/page')));
const SimpletreeSelection = Loadable(lazy(() => import('../views/mui-trees/simpletree/simpletree-selection/page')));

//Error Page
const ErrorPage = Loadable(lazy(() => import("../views/authentication/Error")));



/* Protected Routes (Only Accessible After Login) */
/* ✅ Public Routes (Hanya bisa diakses jika belum login) */
const PublicRoutes = [
  {
    path: "/auth",
    element: <PublicRoute />, // 🔥 Gunakan PublicRoute
    children: [
      {
        path: "/auth",
        element: <BlankLayout />,
        children: [
          { path: "/auth/login", element: <Login /> },
          { path: "/auth/register", element: <Register /> },
          { path: "/auth/404", element: <ErrorPage /> },
        ],
      },
    ],
  },
  // E-mailed reset link. Outside PublicRoute on purpose: it must open even in a
  // browser that is already signed in (possibly as someone else).
  {
    path: "/auth/reset-credentials",
    element: <BlankLayout />,
    children: [{ path: "/auth/reset-credentials", element: <ResetCredentials /> }],
  },
];


const ProtectedRoutes = {
  element: <ProtectedRoute />,
  children: [
    {
      path: "/dashboards",
      element: <FullLayout />,
      children: [
        { index: true, element: <Dashboard /> },
        { path: "/dashboards/modern", element: <ModernDash /> },
        { path: "/dashboards/modern-detail", element: <ModernDetail /> },
        { path: "/dashboards/monitoring-detail", element: <Monitoring /> },
      ],
    },
    {
      path: "/bnf-monitoring",
      element: <FullLayout />,
      children: [{ index: true, element: <BnfMonitoring /> }],
    },
    {
      path: "/dashboards-monitoring",
      element: <FullBlankLayout />,
      children: [
        { index: true, element: <Dashboard /> },
        { path: "/dashboards-monitoring/modern", element: <ModernDash /> },
        { path: "/dashboards-monitoring/modern-detail", element: <ModernDetail /> },
        { path: "/dashboards-monitoring/monitoring-detail", element: <Monitoring /> },
      ],
    },    
    {
      path: "/managements",
      element: <FullLayout />,
      children: [
        { path: "/managements/users", element: <Users /> },
        { path: "/managements/add/users", element: <AddUsers /> },
        { path: "/managements/edit/users", element: <AddUsers /> },
        { path: "/managements/detail/users", element: <DetailUser /> },

        { path: "/managements/roles", element: <Roles /> },
        { path: "/managements/add/roles", element: <AddRoles /> },
        { path: "/managements/edit/roles", element: <AddRoles /> },
        { path: "/managements/detail/roles", element: <DetailRole /> },

        { path: "/managements/shift-times", element: <ShiftTimes /> },
        { path: "/managements/add/shift-times", element: <AddShiftTime /> },
        { path: "/managements/edit/shift-times", element: <AddShiftTime /> },

        { path: "/managements/email-templates", element: <EmailTemplates /> },
        { path: "/managements/email-templates/add", element: <AddEmailTemplates /> },
        { path: "/managements/email-templates/edit", element: <EditEmailTemplates /> },
        { path: "/managements/email-templates/detail", element: <DetailEmailTemplates /> },

        { path: "/managements/email-schedules", element: <EmailSchedules /> },
        { path: "/managements/add/email-schedules", element: <AddEmailSchedules /> },
        { path: "/managements/edit/email-schedules", element: <EditEmailSchedules /> },
        { path: "/managements/detail/email-schedules", element: <DetailEmailSchedules /> },

        { path: "/managements/email-recipients", element: <EmailRecipients /> },
        { path: "/managements/email-recipients/add", element: <AddEmailRecipients /> },
        { path: "/managements/email-recipients/edit", element: <EditEmailRecipients /> },
        { path: "/managements/email-recipients/detail", element: <DetailEmailRecipients /> },



        { path: "/managements/materials", element: <Materials /> },
        { path: "/managements/add/materials", element: <AddMaterials /> },
        { path: "/managements/edit/materials", element: <AddMaterials /> },
        { path: "/managements/detail/materials", element: <DetailMaterials /> },

        { path: "/managements/systems/:configType", element: <System /> },
        { path: "/managements/system", element: <System /> },
        { path: "/managements/add/system/:configType", element: <AddSystem /> },
        { path: "/managements/add/system", element: <AddSystem /> },
        { path: "/managements/edit/system", element: <AddSystem /> },
        { path: "/managements/detail/system", element: <DetailSystem /> },

        { path: "/managements/menu-master", element: <MenuMaster /> },
        { path: "/managements/add/menu-master", element: <AddMenuMaster /> },
        { path: "/managements/edit/menu-master", element: <AddMenuMaster /> },
        { path: "/managements/detail/menu-master", element: <DetailMenuMaster /> },

        { path: "/managements/vendors", element: <Vendors /> },
        { path: "/managements/add/vendors", element: <AddVendors /> },
        { path: "/managements/edit/vendors", element: <AddVendors /> },
        { path: "/managements/detail/vendors", element: <DetailVendors /> },

        { path: "/managements/ews-report", element: <EwsReport /> },
        { path: "/managements/bnf-stock", element: <StockReport /> },
        { path: "/managements/bnf-material", element: <FourmReport /> },



        { path: "/managements/inventories/history", element: <Inventorys /> },
        { path: "/managements/inventories/update-stock", element: <UpdateStock /> },
        { path: "/managements/inventories/history-update-stock", element: <UpdateStockHistory /> },
        
        { path: "/managements/login-activity", element: <LoginActivity /> },
        { path: "/managements/email-logs", element: <EmailLog /> },

        { path: "/managements/business", element: <Business /> },
        { path: "/managements/add/business", element: <AddBusiness /> },
        { path: "/managements/edit/business", element: <AddBusiness /> },
        { path: "/managements/detail/business", element: <DetailBusiness /> },


        { path: "/managements/forecast", element: <Forecast /> },        
        { path: "/managements/forecast-supplier", element: <Forecastsupplier /> },
      ],
    },

    {
      path: "/settings",
      element: <FullLayout />,
      children: [

        { path: "/settings/menu-grouping", element: <MenusGrouping /> },
        { path: "/settings/add/menu-grouping", element: <AddMenusGrouping /> },
        { path: "/settings/edit/menu-grouping", element: <AddMenusGrouping /> },
        { path: "/settings/detail/menu-grouping", element: <DetailMenusGrouping /> },



        { path: "/settings/roles-permission", element: <RolesPermission /> },
        { path: "/settings/add/roles-permission", element: <AddRolesPermission /> },
        { path: "/settings/edit/roles-permission", element: <AddRolesPermission /> },
        { path: "/settings/detail/roles-permission", element: <DetailRolesPermission /> },


        // { path: "/managements/vendors", element: <Vendors /> },
        // { path: "/managements/add/vendors", element: <AddVendors /> },
        // { path: "/managements/edit/vendors", element: <AddVendors /> },
        // { path: "/managements/detail/vendors", element: <DetailVendors /> },

        // { path: "/managements/business", element: <Business /> },
        // { path: "/managements/add/business", element: <AddBusiness /> },
        // { path: "/managements/edit/business", element: <AddBusiness /> },
        // { path: "/managements/detail/business", element: <DetailBusiness /> },
      ],
    },

    {
      path: "/apps",
      element: <FullLayout />,
      children: [
        { path: "/apps/chat", element: <Chats /> },
        { path: "/apps/notes", element: <Notes /> },
        { path: "/apps/calendar", element: <Calendar /> },
        { path: "/apps/email", element: <Email /> },
        { path: "/apps/tickets", element: <Tickets /> },
        { path: "/apps/contacts", element: <Contacts /> },
        { path: "/apps/ecommerce/shop", element: <Ecommerce /> },
        { path: "/apps/ecommerce/eco-product-list", element: <EcomProductList /> },
        { path: "/apps/ecommerce/eco-checkout", element: <EcomProductCheckout /> },
        { path: "/apps/ecommerce/add-product", element: <EcommerceAddProduct /> },
        { path: "/apps/ecommerce/edit-product", element: <EcommerceEditProduct /> },
        { path: "/apps/ecommerce/detail/:id", element: <EcommerceDetail /> },
        { path: "/apps/kanban", element: <Kanban /> },
      ],
    },
    {
      path: "/invoices",
      element: <FullLayout />,
      children: [
        { path: "/invoices/list", element: <InvoiceList /> },
        { path: "/invoices/create", element: <InvoiceCreate /> },
        { path: "/invoices/detail/:id", element: <InvoiceDetail /> },
        { path: "/invoices/edit/:id", element: <InvoiceEdit /> },
      ],
    },
    {
      path: "/user-profile",
      element: <FullLayout />,
      children: [
        { path: "/user-profile", element: <UserProfile /> },
        { path: "/user-profile/followers", element: <Followers /> },
        { path: "/user-profile/friends", element: <Friends /> },
        { path: "/user-profile/gallery", element: <Gallery /> },
      ],
    },
    {
      path: "/pages",
      element: <FullLayout />,
      children: [
        { path: "/pages/casl", element: <RollbaseCASL /> },
        { path: "/pages/pricing", element: <Pricing /> },
        { path: "/pages/account-settings", element: <AccountSetting /> },
        { path: "/pages/faq", element: <Faq /> },
      ],
    },
    {
      path: "/forms",
      element: <FullLayout />,
      children: [
        { path: "/forms/form-elements/autocomplete", element: <MuiAutoComplete /> },
        { path: "/forms/form-elements/button", element: <MuiButton /> },
        { path: "/forms/form-elements/checkbox", element: <MuiCheckbox /> },
        { path: "/forms/form-elements/radio", element: <MuiRadio /> },
        { path: "/forms/form-elements/slider", element: <MuiSlider /> },
        { path: "/forms/form-elements/date-time", element: <MuiDateTime /> },
        { path: "/forms/form-elements/date-range", element: <MuiDateTime /> },
        { path: "/forms/form-elements/switch", element: <MuiSwitch /> },
        { path: "/forms/form-tiptap", element: <TiptapEditor /> },
        { path: "/forms/form-layouts", element: <FormLayouts /> },
        { path: "/forms/form-horizontal", element: <FormHorizontal /> },
        { path: "/forms/form-vertical", element: <FormVertical /> },
        { path: "/forms/form-custom", element: <FormCustom /> },
        { path: "/forms/form-wizard", element: <FormWizard /> },
        { path: "/forms/form-validation", element: <FormValidation /> },
      ],
    },
    {
      path: "/tables",
      element: <FullLayout />,
      children: [
        { path: "/tables/basic", element: <BasicTable /> },
        { path: "/tables/collapsible", element: <CollapsibleTable /> },
        { path: "/tables/enhanced", element: <EnhancedTable /> },
        { path: "/tables/fixed-header", element: <FixedHeaderTable /> },
        { path: "/tables/pagination", element: <PaginationTable /> },
        { path: "/tables/search", element: <SearchTable /> },
      ],
    },
    {
      path: "/charts",
      element: <FullLayout />,
      children: [
        { path: "/charts/line-chart", element: <LineChart /> },
        { path: "/charts/gredient-chart", element: <GredientChart /> },
        { path: "/charts/doughnut-pie-chart", element: <DoughnutChart /> },
        { path: "/charts/area-chart", element: <AreaChart /> },
        { path: "/charts/column-chart", element: <ColumnChart /> },
        { path: "/charts/candlestick-chart", element: <CandlestickChart /> },
        { path: "/charts/radialbar-chart", element: <RadialbarChart /> },
      ],
    },
    {
      path: "/ui-components",
      element: <FullLayout />,
      children: [
        { path: "/ui-components/alert", element: <MuiAlert /> },
        { path: "/ui-components/accordion", element: <MuiAccordion /> },
        { path: "/ui-components/avatar", element: <MuiAvatar /> },
        { path: "/ui-components/chip", element: <MuiChip /> },
        { path: "/ui-components/dialog", element: <MuiDialog /> },
        { path: "/ui-components/list", element: <MuiList /> },
        { path: "/ui-components/popover", element: <MuiPopover /> },
        { path: "/ui-components/rating", element: <MuiRating /> },
        { path: "/ui-components/tabs", element: <MuiTabs /> },
        { path: "/ui-components/tooltip", element: <MuiTooltip /> },
        { path: "/ui-components/transfer-list", element: <MuiTransferList /> },
        { path: "/ui-components/typography", element: <MuiTypography /> },
      ],
    },
    {
      path: "/widgets",
      element: <FullLayout />,
      children: [
        { path: "/widgets/cards", element: <WidgetCards /> },
        { path: "/widgets/banners", element: <WidgetBanners /> },
        { path: "/widgets/charts", element: <WidgetCharts /> },
      ],
    },
    {
      path: "/react-tables",
      element: <FullLayout />,
      children: [
        { path: "/react-tables/basic", element: <ReactBasicTable /> },
        { path: "/react-tables/column-visiblity", element: <ReactColumnVisibilityTable /> },
        { path: "/react-tables/drag-drop", element: <ReactDragDropTable /> },
        { path: "/react-tables/dense", element: <ReactDenseTable /> },
        { path: "/react-tables/editable", element: <ReactEditableTable /> },
        { path: "/react-tables/empty", element: <ReactEmptyTable /> },
        { path: "/react-tables/expanding", element: <ReactExpandingTable /> },
        { path: "/react-tables/filter", element: <ReactFilterTable /> },
        { path: "/react-tables/pagination", element: <ReactPaginationTable /> },
        { path: "/react-tables/row-selection", element: <ReactRowSelectionTable /> },
        { path: "/react-tables/sorting", element: <ReactSortingTable /> },
        { path: "/react-tables/sticky", element: <ReactStickyTable /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/auth/404" />,
    },
  ],
};

// Attach RouteErrorFallback to every top-level route so react-router's raw
// "Unexpected Application Error!" screen is never shown to a user; errors
// bubble up from children to the nearest errorElement. Spreading `route` last
// lets an individual route declare its own errorElement if it ever needs to.
const withErrorFallback = (routes) =>
  routes.map((route) => ({ errorElement: <RouteErrorFallback />, ...route }));

const router = createBrowserRouter(
  withErrorFallback([
    // The dashboard route is "/dashboards" (plural) — the previous "/dashboard"
    // matched nothing, so opening the site root landed on the error page.
    { path: "/", element: <Navigate to="/dashboards" replace /> },
    ...PublicRoutes,
    ProtectedRoutes,
    { path: "*", element: <ErrorPage /> }, // ✅ Jika rute tidak ditemukan, tampilkan halaman error
  ]),
);


export default router;


